var map = {
	"./arrow_icon.png": 81331,
	"./float_bc.png": 71382,
	"./float_bc_active.png": 70652,
	"./junpintan.png": 33388,
	"./light.png": 76729,
	"./logo.png": 5330,
	"./next.png": 64699,
	"./next2.png": 41701,
	"./page_2_bc.png": 63019,
	"./page_3_bc.png": 66567,
	"./page_3_swiper_bc.png": 39324,
	"./page_4_bc.png": 45961,
	"./people_after.png": 76914,
	"./people_before.png": 92539,
	"./play.png": 82011,
	"./play_main.png": 71408,
	"./play_white.png": 29018,
	"./prev.png": 86933,
	"./prev2.png": 45671,
	"./xi_image.png": 898,
	"./xi_text.png": 55755
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 67112;